import { SVGPureIcon } from '@/ui';
import { Upload } from 'antd';
import ImageUploadProgress from '@/components/aigc-form/uploader/progress';
import { getAcceptByMediaType, IMAGE_ACCEPT } from '@/utils/get-mime';
import './index.scss';

const ImageUploader = ({
  maxCount = 1,
  shownImg,
  uploadProgress,
  onBeforeUpload,
  className = '',
}) => {
  return (
    <Upload.Dragger
      maxCount={maxCount}
      showUploadList={false}
      accept={getAcceptByMediaType('image')}
      className={`flex-1 group modify-image-uploader w-full h-full relative ${className}`}
      beforeUpload={e => false}
      onChange={e => {
        onBeforeUpload(
          e.fileList.slice(0, maxCount).map(item => item.originFileObj)
        );
      }}
      onDrop={e => {
        onBeforeUpload(
          Array.from(e.dataTransfer.files).slice(0, maxCount),
          true
        );
      }}
    >
      {!uploadProgress && (
        <div
          className="absolute left-14px bottom-8px z-9 flex gap-4px items-center bg-[#FFFFFFCC] hover:bg-white justify-center w-52px h-24px text-12px rounded-6px"
          style={{
            backdropFilter: 'blur(8px)',
          }}
        >
          <SVGPureIcon name="modify-upload" size={12} />
          换图
        </div>
      )}
      <div className="flex flex-col gap-6px items-center relative justify-center h-full text-14px overflow-hidden rounded-8px">
        {!!uploadProgress && <ImageUploadProgress progress={uploadProgress} />}
      </div>
      {shownImg  && (
        <div className="relative">
          <img
            src={shownImg}
            className="rounded-8px w-80px h-80px object-cover"
          />
          <div className="absolute inset-0 bg-white bg-opacity-30 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-8px"></div>
        </div>
      )}
    </Upload.Dragger>
  );
};

export default ImageUploader;
